import classnames from 'classnames';
import React from 'react';
import { getErrorInfo } from './helpers';

function getDisabledPart({ input }) {
  return (
    <span className={classnames('new-design-field', 'sub-class-disabled')}>
      {input.value}
    </span>
  );
}

function getInputPart({ input, ...p }) {
  return (
    <input
      className="new-design-field"
      type={p.type}
      placeholder={p.placeholder}
      autoComplete={p.autoComplete}
      {...input}
    />
  );
}

export function PureNewTextField({ meta, ...p }) {
  return (
    <div className="scope-field-container">
      <div className="scope-field-label">{p.label} *</div>
      {p.disabled ? getDisabledPart(p) : getInputPart(p)}
      {getErrorInfo(meta)}
    </div>
  );
}

